import { IconPlus, IconX } from "@tabler/icons-react";
import { NavLink } from "react-router";
// @ts-ignore
import Cookies from "js-cookie";
// controllers
import { LogOut } from "../../services/client/auth/logOut";
import { useMutation } from "@tanstack/react-query";
import useGetData from "../../hook/getData";
import { GetWallet } from "../../services/panel/wallet/getWallet";
import { useForm } from "react-hook-form";
import { onError } from "../../features/error/error";
import { SendWallet } from "../../services/panel/wallet/chargeWallet";
import { toast } from "react-toastify";
import { toastOptions } from "../../features/toast/toast";
const Menu = (props: any) => {
    const { data: wallet } = useGetData(['wallet'], GetWallet)
    const { register, handleSubmit }: any = useForm<any>();
    const mutation = useMutation({
        mutationFn: LogOut,
        onSuccess: () => {
            Cookies.remove('agent_token');
            localStorage.removeItem('image');
            localStorage.removeItem('name');
            localStorage.removeItem('lastName');
            localStorage.removeItem('email');
            localStorage.removeItem('nationalCode');
            localStorage.removeItem('gender');
            localStorage.removeItem('cellphone');
            localStorage.removeItem('username');
            localStorage.removeItem('profile_page_refreshed')
            window.open('/', '_self')
        },
        onError: (error: any) => {
            console.log(error)
        },
    });
    const paymentMutation = useMutation({
        mutationFn: SendWallet,
        onSuccess: (data) => {
            window.open(data.paymentLink, '_self');
        },
        onError: (error: any) => {
            const errors: any = error.response.data?.message;
            toast.error(errors, toastOptions);
            if (errors) {
                for (const [, messages] of Object.entries(errors)) {
                    (messages as string[]).forEach((message) => {
                        toast.error(message, toastOptions);
                    });
                }
            }
        },
    });

    const onSubmit = (data: any) => {
        paymentMutation.mutate(data);
    }
    return (
        <>
            <section className="card d-lg-block d-none card-body border-1 rounded rounded-4 shadow ">
                <div className="profile">
                    <div className="d-flex">
                        <div className="d-flex justify-content-center">
                            <img alt="category" src={localStorage.getItem('image') ? localStorage.getItem('image') : require('./../../assets/media/logo/final.png')} />
                        </div>
                        <p className="text-center ms-2 mb-0 fw-bold font-medium-lg mt-3">
                            {localStorage.getItem('cellphone') ? localStorage.getItem('cellphone') : 'شماره تماس'}
                        </p>
                    </div>
                    <div className="rounded box-site rounded-4 d-flex justify-content-between align-items-center mt-3 mb-0">
                        <span>کیف پول</span>
                        <div className="d-flex align-items-center">
                            <span>
                                {wallet?.balance}
                                {/* @ts-ignore */}
                                <span className="mx-1 me-3">تومان</span>
                            </span>
                            <button data-bs-toggle="modal" data-bs-target="#wallet-modal" className="btn text-white" style={{ backgroundColor: 'rgb(18 184 134)' }}>
                                <IconPlus size={16} />
                            </button>
                        </div>
                    </div>
                </div>
            </section>
            <section className="card d-lg-block d-none card-body border-1 rounded rounded-4 shadow mt-3" >
                <ul className="list-group profile-list border-0 px-0">
                    {props.routes?.map((link: any) => (
                        <li className="px-0 list-group-item py-2">
                            <NavLink to={link.address} className={'text-decoration-none font-medium text-black'}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="font-medium">
                                        {link.icon}
                                        <span className="ms-2">
                                            {link.label}
                                        </span>
                                    </div>
                                </div>
                            </NavLink>
                        </li>
                    ))}
                    <li className="px-0 list-group-item py-2">
                        <hr />
                        <span style={{ cursor: 'pointer' }} onClick={() => mutation.mutate()} className="text-danger fw-bold">
                            خروج از حساب
                        </span>
                    </li>
                </ul>
            </section>
            <div className="offcanvas w-75 offcanvas-start" id="offcanvas-admin">
                <div className="offcanvas-body">
                    <section className="card card-body border-1 rounded rounded-4 shadow ">
                        <div className="profile">
                            <div className="d-flex">
                                <div className="d-flex justify-content-center">
                                    <img alt="category" src={localStorage.getItem('image') ? localStorage.getItem('image') : require('./../../assets/media/logo/final.png')} />
                                </div>
                                <p className="text-center ms-2 mb-0 fw-bold font-medium-lg mt-3">
                                    {localStorage.getItem('cellphone') ? localStorage.getItem('cellphone') : 'شماره تماس'}
                                </p>
                            </div>
                            <div className="rounded box-site rounded-4 d-flex justify-content-between align-items-center mt-3 mb-0">
                                <span>کیف پول</span>
                                <div className="d-flex align-items-center">
                                    <span>
                                        0
                                        <span className="mx-1 me-3">تومان</span>
                                    </span>
                                    <button className="btn text-white" style={{ backgroundColor: 'rgb(18 184 134)' }}>
                                        <IconPlus size={16} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="card  card-body border-1 rounded rounded-4 shadow mt-3" >
                        <ul className="list-group profile-list border-0 px-0">
                            {props.routes?.map((link: any) => (
                                <li className="px-0 list-group-item py-2">
                                    <NavLink to={link.address} className={'text-decoration-none font-medium text-black'}>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div className="font-medium">
                                                {link.icon}
                                                <span className="ms-2">
                                                    {link.label}
                                                </span>
                                            </div>
                                        </div>
                                    </NavLink>
                                </li>
                            ))}
                            <li className="px-0 list-group-item py-2">
                                <hr />
                                <span style={{ cursor: 'pointer' }} onClick={() => mutation.mutate()} className="text-danger fw-bold">
                                    خروج از حساب
                                </span>
                            </li>
                        </ul>
                    </section>
                </div>
            </div>
            <div className="modal fade" id="wallet-modal">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header justify-content-between">
                            <h6 className="fw-bold text-site">
                                شارژ کیف پول
                            </h6>
                            <IconX data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(onSubmit, onError)}>
                                <fieldset className="form-floating my-3">
                                    <input type="text" className="form-control"
                                        {...register("amount", { required: 'فیلد الزامی است' })}
                                    />
                                    <label className="form-label">
                                        مبلغ (تومان)
                                    </label>
                                </fieldset>
                                <button className="w-100 btn btn-outline-primary py-3">
                                    شارژ کیف پول
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Menu;